module.exports = __webpack_public_path__ + "static/media/bg_finish.77907f20.png";